<script>
  // Renders a registry icon by string key. Size is driven by the `size` token
  // (mapped to explicit pixels) so dimensions are deterministic; `class` is for
  // color/spacing only (e.g. class="text-error"). Unknown names fall back to a
  // question-mark icon via iconFor().
  import { iconFor } from '../../lib/icons.js'

  let { name, size = 'md', class: className = '', ...rest } = $props()

  const PX = { xs: 14, sm: 16, md: 20, lg: 24, xl: 32 }

  const Cmp = $derived(iconFor(name))
  const px = $derived(String(PX[size] ?? PX.md))
</script>

<Cmp size={px} class={className} {...rest} />
